import { render } from "./SidebarGroup.vue?vue&type=template&id=2c9ab99f&scoped=true"
import script from "./SidebarGroup.vue?vue&type=script&lang=js"
export * from "./SidebarGroup.vue?vue&type=script&lang=js"

import "./SidebarGroup.vue?vue&type=style&index=0&id=2c9ab99f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9ab99f"]])

export default __exports__